module.exports = __webpack_public_path__ + "img/environment-banner.91fed173.jpg";